import {IChapterCue} from '@utils/parseChapterMarks';
import {motion} from 'framer-motion';
import {getCueFillPercent, getCueWidthPercent} from '../../@utils/chapterMath';
import {CHAPTER_PROGRESS_TRANSITION} from '../ChaptersProgressBar';
import styles from './ChaptersProgressBarSegments.module.css';

const ChaptersProgressBarSegments = ({
    cues,
    duration,
    currentTime,
    hoveredTime,
    hoveredChapterIndex,
    isUserInteracting,
}: {
    cues: IChapterCue[];
    duration: number;
    currentTime: number;
    hoveredTime: number | null;
    hoveredChapterIndex: number | null;
    isUserInteracting: boolean;
}) => {
    return (
        <motion.div className={styles.chaptersOverlay}>
            {cues.map((cue, i) => {
                const segmentWidth = getCueWidthPercent(cue, duration);

                const watched = getCueFillPercent(cue, currentTime);

                const hover = getCueFillPercent(cue, hoveredTime ?? 0);

                const hoverStart = Math.max(watched, 0);
                const hoverEnd = Math.min(hover, 100);
                const hoverWidth = Math.max(0, hoverEnd - hoverStart);

                const shouldScale = hoveredChapterIndex === i;

                return (
                    <motion.div
                        key={cue.startTime + i}
                        className={styles.segment}
                        style={{width: `${segmentWidth}%`}}
                        animate={{scaleY: shouldScale ? 1.8 : 1}}
                        transition={CHAPTER_PROGRESS_TRANSITION}
                        initial={false}
                    >
                        <motion.div
                            className={styles.hoverFill}
                            style={{left: `${hoverStart}%`}}
                            animate={{
                                width: `${hoverWidth}%`,
                                opacity: hoverWidth > 0 ? 1 : 0,
                            }}
                            initial={{opacity: 0}}
                            exit={{opacity: 0}}
                            transition={{
                                duration: 0,
                                opacity: {
                                    duration: 0.3,
                                    ease: 'easeOut',
                                },
                            }}
                        />

                        <motion.div
                            className={styles.fill}
                            animate={{width: `${Math.min(watched, 100)}%`}}
                            transition={
                                isUserInteracting
                                    ? {duration: 0}
                                    : CHAPTER_PROGRESS_TRANSITION
                            }
                            initial={false}
                        />
                    </motion.div>
                );
            })}
        </motion.div>
    );
};

export default ChaptersProgressBarSegments;
